import { atomWithStorage } from "jotai/utils";

export type UnitSystem = "metric" | "imperial";

export const unitSystemAtom = atomWithStorage<UnitSystem>(
  "stratistics:unitSystem",
  "metric",
);
